const vendorConfig = {
    showCompletedForms: true,
}

export default vendorConfig;